import { Button, Modal } from "react-bootstrap";

// Confirmation dialog styled by the design system (theme/bridge.css), used
// instead of the browser's window.confirm.
type Props = {
  show: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: "primary" | "danger" | "success";
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmModal = ({
  show,
  title,
  message,
  confirmLabel = "Confirmar",
  variant = "primary",
  onConfirm,
  onCancel,
}: Props) => (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{message}</Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onCancel}>
        Cancelar
      </Button>
      <Button variant={variant} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal;
